import React from "react";
import { AddressList, EmailList, TelephoneList } from "@pages/ProfilePage/components";
import { InfoCard, CardDivider } from "@components/styles/dataDisplay";
import { FetchCustomerData } from "@customTypes/responses/customer";
import { CustomHeading } from "@pages/style";
import CustomerInfoTabSkeleton from "@pages/skeletons/CustomerInfoTabSkeleton";
import { LabeledRow } from "@components/LabeledRow";
import { bankAccountTypeMap, documentMap, subtextMap } from "./constants";
import { ProfileDataContainer } from "../style";
import { useQuery } from "react-query";

const CustomerInfoTab: React.FC = () => {
  const { data: customerData, isLoading } = useQuery<FetchCustomerData>(["customerInfo"]);

  if (!customerData) return null;

  if (isLoading) return <CustomerInfoTabSkeleton />;

  const shouldShowBankData = Object.keys(customerData.bank).length > 0;

  return (
    <InfoCard spacing="lg" border>
      <CustomHeading noMargin size="sm">
        {subtextMap[customerData.contactKind]}
      </CustomHeading>
      <ProfileDataContainer>
        <LabeledRow label="Nome" value={customerData.name} />
        <EmailList emails={customerData.email} />
        <TelephoneList telephones={customerData.telephone} />
        <AddressList addresses={customerData.address} />
        <LabeledRow label={documentMap[customerData.contactKind]} value={customerData.document} />
      </ProfileDataContainer>
      {shouldShowBankData && (
        <>
          <CardDivider />
          <CustomHeading noMargin size="sm">
            Dados bancários
          </CustomHeading>
          <ProfileDataContainer>
            <LabeledRow
              label="Tipo de conta"
              value={bankAccountTypeMap[customerData.bank.accountType]}
            />
            <LabeledRow label="Banco" value={customerData.bank.name} />
            <LabeledRow label="Conta" value={customerData.bank.account} />
            <LabeledRow label="Agência" value={customerData.bank.agency} />
            <LabeledRow label="PIX" value={customerData.bank.pix} />
          </ProfileDataContainer>
        </>
      )}
    </InfoCard>
  );
};

export default CustomerInfoTab;
